import React from 'react';
import { Box } from '../box';
import { LinearProgress } from '../linear-progress';

export interface IAccordionLoader {
  show?: boolean;
}

export class AccordionLoaderTestIds {
  public static Box = 'box-id';
  public static Progress = 'progress-id';
}

export function AccordionLoader(props: IAccordionLoader) {
  const { show = false } = props;

  return (
    <Box className={show ? 'is-visible' : 'is-hidden'} position="absolute" top={0} left={0} right={0} height={4} zIndex={2} data-testid={AccordionLoaderTestIds.Box}>
      <LinearProgress show={show} data-testid={AccordionLoaderTestIds.Progress} />
    </Box>
  );
}
